// CSS
import "./styles/global.scss";

// JS
import $ from 'jquery';


window.jQuery = window.$ = $;
require('jquery-validation');
require("slick-carousel");
require( 'datatables.net' );
require('prismjs');
require("flatpickr");

import '/node_modules/@qhealth-design-system/core/src/components/_global/js/global.js';


import '/node_modules/@qhealth-design-system/core/src/components/_global/js/user_location/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/_global/js/tabs/global.js'; 
import '/node_modules/@qhealth-design-system/core/src/components/_global/js/slick/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/_global/js/modal/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/_global/js/forms/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/_global/js/animate/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/_global/js/_polyfills/global.js';




import '/node_modules/@qhealth-design-system/core/src/components/accordion/js/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/global_alert/js/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/header/js/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/left_hand_navigation/js/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/in_page_navigation/js/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/main_navigation/js/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/mega_main_navigation/js/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/code/js/global.js';
import '/node_modules/@qhealth-design-system/core/src/components/tab/js/global.js';